import React from 'react';
import TimedPill from './TimedPill';

const PillList = ({ items, getTooltip, idPrefix }) => (
  <div className="pill-container" role="list">
    {(items && items.length > 0)
      ? items.map((it, i) => (
          <TimedPill
            key={i}
            id={`${idPrefix}-${i}`}
            label={it}
            tooltipText={getTooltip(it)}
          />
        ))
      : <span className="pill empty">—</span>
    }
  </div>
);

export default PillList;
